import { render } from "./NewPostPopup.vue?vue&type=template&id=4479743e&scoped=true"
import script from "./NewPostPopup.vue?vue&type=script&lang=js"
export * from "./NewPostPopup.vue?vue&type=script&lang=js"

import "./NewPostPopup.vue?vue&type=style&index=0&id=4479743e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4479743e"]])

export default __exports__